import PropTypes from 'prop-types';

export const itemActionsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    addtocart: PropTypes.string,
    deletelist: PropTypes.string,
    duplicatelist: PropTypes.string
  })
);

export const commonItemPropType = PropTypes.shape({
  actions: itemActionsPropType,
  createdBy: PropTypes.string,
  lastUpdate: PropTypes.shape({
    unformattedDate: PropTypes.string,
    formattedDate: PropTypes.string
  }),
  name: PropTypes.string,
  orderId: PropTypes.string,
  quantity: PropTypes.number,
  reactKey: PropTypes.string,
  status: PropTypes.string,
  type: PropTypes.string,
  updated: PropTypes.number,
  updatedDisplayValue: PropTypes.string
});
